import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const formStyles: BoxStyleProps = {
    padding: "space40",
    paddingTop: "space80",
    overflow: "auto"
};

export const titleStyles: TextStyleProps = {
    fontSize: "fontSize70",
    marginBottom: "space60"
};

export const introStyles: TextStyleProps = {
    marginBottom: "space70"
};

export const fieldStyles: BoxStyleProps = {
    marginBottom: "space70"
};

export const cardsContainerStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "column",
    marginBottom: "space50"
};

export const buttonContainerStyles: BoxStyleProps = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

export const backButtonStyles: BoxStyleProps = {
    display: "flex",
    alignItems: "center",
    border: "none",
    backgroundColor: "transparent",
    color: "colorText",
    cursor: "pointer",
    padding: "space0",
    marginRight: "space40",
    fontSize: "fontSize30",
    outline: "0px",
    _hover: {
        color: "colorTextWeak"
    },
    _focusVisible: {
        boxShadow: "shadowFocus"
    }
};

/*
 * Voltar das telas de PROMOÇÕES. Diferente do `backButtonStyles` (que é um link discreto dentro do
 * formulário, ao lado do botão de enviar): aqui ele é a ÚNICA saída da tela, e sem aparência de
 * botão o apostador não percebe que dá para voltar — foi o retorno do Mateus em 2026-08-06.
 */
export const voltarPromocoesStyles: BoxStyleProps = {
    display: "inline-flex",
    alignItems: "center",
    columnGap: "space20",
    alignSelf: "flex-start",
    marginBottom: "space50",
    paddingTop: "space20",
    paddingBottom: "space20",
    paddingLeft: "space40",
    paddingRight: "space40",
    borderStyle: "solid",
    borderWidth: "borderWidth10",
    borderColor: "colorBorderWeaker",
    borderRadius: "borderRadius20",
    backgroundColor: "colorBackgroundBody",
    color: "colorText",
    fontSize: "fontSize20",
    fontWeight: "fontWeightSemibold",
    cursor: "pointer",
    outline: "0px",
    _hover: {
        backgroundColor: "colorBackgroundStrong",
        borderColor: "colorBorderWeak"
    },
    _focusVisible: {
        boxShadow: "shadowFocus"
    }
};

export const cardStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
    marginBottom: "space40",
    padding: "space50",
    backgroundColor: "colorBackgroundBody",
    borderWidth: "borderWidth10",
    borderStyle: "solid",
    borderColor: "colorBorderWeaker",
    borderRadius: "borderRadius30",
    cursor: "pointer",
    textAlign: "left",
    transition: "background-color 0.2s, border-color 0.2s",
    _hover: {
        backgroundColor: "colorBackgroundStrong"
    },
    _focusVisible: {
        boxShadow: "shadowFocus",
        outline: "0px"
    }
};

export const cardTitleStyles: TextStyleProps = {
    fontSize: "fontSize40",
    fontWeight: "fontWeightSemibold",
    color: "colorText"
};

/**
 * Linha de validade da promoção ("Válida até …"), na lista e embaixo do título.
 *
 * Fica visivelmente abaixo do nome da oferta: é informação de apoio, não manchete. O painel tem
 * 380px, então a frase quebra em duas linhas em vez de truncar — cortar em "até 10/08…" esconderia
 * justamente a parte que o apostador foi ler.
 */
export const janelaPromocaoStyles: TextStyleProps = {
    fontSize: "fontSize20",
    color: "colorTextWeak",
    marginTop: "space20"
};

export const cardSubtitleStyles: TextStyleProps = {
    fontSize: "fontSize20",
    color: "colorTextWeak",
    marginTop: "space10"
};
